import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isObservable, Observable, Subscription } from 'rxjs';

export interface TextViewerDialogData {
  title?: string
  text?: string
  text$?: Observable<string>
}

@Component({
  host: {
    class: 'mat-dialog-component',
    'test-id': 'text-viewer-dialog',
  },
  selector: 'text-viewer-dialog',
  templateUrl: './text-viewer-dialog.component.html',
  styles: [`
    .loading {
      align-items: center;
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;

      .mat-mdc-progress-spinner {
        margin-bottom: 10px;
      }
    }
  `],
})
export class TextViewerDialog {
  public title: string
  public text: string
  public isLoading = true

  private subscriptions = {
    text: Subscription.EMPTY,
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: TextViewerDialogData = {},
    public dialogRef: MatDialogRef<TextViewerDialog>,
  ) {
    this.title = data.title;
    if (isObservable(data.text$)) {
      this.subscriptions.text = this.data.text$.subscribe((text) => {
        this.text = text;
        this.isLoading = false;
      });
    } else {
      this.text = data.text;
      this.isLoading = false;
    }
  }

  ngOnDestroy(): void {
    for (const subscription of Object.values(this.subscriptions)) {
      subscription.unsubscribe();
    }
  }
}
